/**
 * Maps a feed AggregatorName to the Aggregator API path segment used by
 * `GET /api/Firm/{Aggregator}/Accounts/{wealthId}` (legacy Institution.jsx
 * `reloadAccounts`).
 */
export function mapFirmAggregatorName(
  aggregatorName: string | null | undefined,
): string | null {
  if (aggregatorName == null) {
    return null;
  }
  const trimmed = aggregatorName.trim();
  if (!trimmed) {
    return null;
  }
  return trimmed.toUpperCase() === 'BAA' ? 'ByAll' : trimmed;
}
